import graphql from "babel-plugin-relay/macro";

const OverrideReportPageCSVQuery = graphql`
  query OverrideReportPageCSVQuery {
    overrideReportCsv {
      taskId
    }
  }
`;

export default OverrideReportPageCSVQuery;
